import React from 'react';
import { Box, Typography } from '@mui/material';
import { AnnouncementOutlined } from '@mui/icons-material';

import { DashboardMetricCardWrapper } from 'components/dashboard-metric-card';
import { useScansCount } from 'store/apis';
import { BarChartVertical } from './bar-chart-vertical';

interface ChartTotalScansProps {
  buildingId: number;
  start: string;
  end: string;
}

export const ChartTotalScans = ({ buildingId, start, end }: ChartTotalScansProps) => {
  const { data, isFetching } = useScansCount({ buildingId, start, end });

  return (
    <DashboardMetricCardWrapper
      title="Total Scans"
      subtitle="Per Zone"
      loading={isFetching}
      loadingText="Loading scans..."
    >
      {data.labels.length === 0 && (
        <Box sx={{ textAlign: 'center' }}>
          <AnnouncementOutlined color="primary" sx={{ fontSize: 40 }} />

          <Typography color="primary" sx={{ marginTop: 2 }}>
            No scans info
          </Typography>

          <Typography color="textSecondary" sx={{ fontSize: 12, marginTop: 1 }}>
            Choose the valid date range.
          </Typography>
        </Box>
      )}

      {data.labels.length > 0 && <BarChartVertical data={data} />}
    </DashboardMetricCardWrapper>
  );
};
